export const sermons = [
  {
    id: 1,
    title: "The Lord Is Never Absent",
    speaker: "Dcns. Dr Gloria Ajongba",
    date: "2026-02-15",
    link: "https://rare-humor-098.notion.site/The-Lord-Is-Never-Absent-30b1d7a737538fb91ddf19d1c445b6"
  },
  {
    id: 2,
    title: "Believe Not Every Spirit",
    speaker: "Eld. Solomon Naryertey",
    date: "2026-02-08",
    link: "https://rare-humor-098.notion.site/Believe-Not-Every-Spirit-3041d7a73753802eb35df7f43f6b576c"
  },
  {
    id: 3,
    title: "To What Measure Are You Using the Word?",
    speaker: "Eld. David Mensah",
    date: "2026-02-01",
    link: "https://rare-humor-098.notion.site/To-What-Measure-Are-You-Using-the-Word-2fd1d7a737538050f46d66d73e628d9"
  },
  {
    id: 4,
    title: "The Personality of the Holy Spirit",
    speaker: "Benjamin Jr Apenteng",
    date: "2026-01-30",
    link: "https://rare-humor-098.notion.site/The-Personality-of-the-Holy-Spirit-2ff1d7a73753800197e3360d9a013b"
  },
  {
    id: 5,
    title: "Character and Power – Living the True Gospel",
    speaker: "Ovrs. Andrew Afropong",
    date: "2026-01-25",
    link: "https://rare-humor-098.notion.site/Character-and-Power-Living-the-True-Gospel-2f61d7a7375380d88643e755e148b168"
  },
  {
    id: 6,
    title: "Take Your Stand",
    speaker: "Dcn. Paul Mensah",
    date: "2025-11-16",
    link: "https://rare-humor-098.notion.site/Take-Your-Stand-2b11d7a73753804e9cafc3133cdac1b2"
  },
  {
    id: 7,
    title: "Unleashed with the Holy Ghost Fire",
    speaker: "Ovrs. Andrew Afropong",
    date: "2025-11-09",
    link: "https://rare-humor-098.notion.site/Unleashed-with-the-Holy-Ghost-Fire-29b1d7a7375380dbbff6ea438ad8c05b"
  },
  {
    id: 8,
    title: "Sacrificial Love: Laying Down Our Lives for One Another",
    speaker: "Eld. Benjamin Apenteng",
    date: "2025-10-19",
    link: "https://rare-humor-098.notion.site/Sacrificial-Love-Laying-Down-Our-Lives-for-One-Another-2951d7a7375380a9a3f3f5f833771937"
  },
  {
    id: 9,
    title: "The Blessing of Sacrifice",
    speaker: "Dcns. Dr Gloria Ajongba",
    date: "2025-10-12",
    link: "https://rare-humor-098.notion.site/The-Blessing-of-Sacrifice-28e1d7a73753805bf8defd295ac13ff"
  },
  {
    id: 10,
    title: "Trust in the Lord Your God",
    speaker: "Prophet Emmanuel Danso",
    date: "2025-10-05",
    link: "https://rare-humor-098.notion.site/Trust-in-the-Lord-Your-God-2861d7a73753807bf95e73e8c41cb21"
  },
  {
    id: 11,
    title: "Unleashed for Impact",
    speaker: "Dcn. Prince Mensah",
    date: "2025-09-28",
    link: "https://rare-humor-098.notion.site/Unleashed-for-Impact-2801d7a73753802b8ae7d425544a6462"
  },
  {
    id: 12,
    title: "Stewardship – Faithful with What God Has Entrusted Me",
    speaker: "Ovrs. Andrew Afropong",
    date: "2025-09-21",
    link: "https://rare-humor-098.notion.site/Stewardship-Faithful-with-What-God-Has-Entrusted-Me-2761d7a73753809fa65ae2958cd8ae4c"
  },
  {
    id: 13,
    title: "Will You Be at the Wedding Feast of the Lamb?",
    speaker: "Apostle S.Y. Antwi",
    date: "2025-09-07",
    link: "https://rare-humor-098.notion.site/Will-You-Be-at-the-Wedding-Feast-of-the-Lamb-26a1d7a73753805ca307d4e5b0c4dd25"
  },
  {
    id: 14,
    title: "Building On The Rock",
    speaker: "Eld. Elvis Boachie",
    date: "2025-08-31",
    link: "https://rare-humor-098.notion.site/Building-On-The-Rock-2631d7a7375380a4ae71e3af4f88c0c4"
  },
  {
    id: 15,
    title: "Desire The Filling of the Holy Spirit and His Works",
    speaker: "Sis Yvette Mensah",
    date: "2025-08-24",
    link: "https://rare-humor-098.notion.site/Desire-The-Filling-of-the-Holy-Spirit-and-His-Works-25c1d7a73753801bbce8dd1796f8bc82"
  },
  {
    id: 16,
    title: "New Creation in Christ: Living as Ambassadors of God's Kingdom",
    speaker: "Ovrs. Andrew Afropong",
    date: "2025-08-03",
    link: "https://rare-humor-098.notion.site/New-Creation-in-Christ-Living-as-Ambassadors-of-Gods-Kingdom-2471d7a73753803797ff8753da17f6"
  },
  {
    id: 17,
    title: "Unleashed to Live a Righteous Life",
    speaker: "Eld. Solomon Naryertey",
    date: "2025-07-27",
    link: "https://rare-humor-098.notion.site/Unleashed-to-Live-a-Righteous-Life-2411d7a73753800bc83c7af7c045227"
  },
  {
    id: 18,
    title: "Essential Virtues for a Fruitful Christian Life",
    speaker: "Eld. J.K Mensah",
    date: "2025-07-20",
    link: "https://rare-humor-098.notion.site/Essential-Virtues-for-a-Fruitful-Christian-Life-2391d7a73753801eabb9dac76b4097f2"
  },
  {
    id: 19,
    title: "Anchoring our Faith",
    speaker: "Dcns. Dr Gloria Ajongba",
    date: "2025-07-13",
    link: "https://rare-humor-098.notion.site/Anchoring-our-Faith-2321d7a73753802c88a0e636644ea013"
  },
  {
    id: 20,
    title: "The Cost of Obedience",
    speaker: "Eld. J.K Mensah",
    date: "2025-07-06",
    link: "https://rare-humor-098.notion.site/The-Cost-of-Obedience-22b1d7a73753804891d97d99f03a70"
  }
];
